<template>
    <vertical-form-table v-model="form" v-bind="{ mode, items }" @input="emit">
        <template slot="사업자등록증">
            <template v-if="mode == 'form'">
                <v-file-input v-model="form.businessRegistration" outlined dense :prepend-icon="null" prepend-inner-icon="mdi-file-upload-outline" :rules="rules[COMPANY.value]?.businessRegistration" @change="emit" />
            </template>
            <template v-if="mode == 'view'">
                <image-popup :src="businessRegistration" :size="100" />
            </template>
        </template>
        <template slot="주소">
            <template v-if="mode == 'form'">
                <v-address-field v-model="form" outlined dense :btnAttrs="{ color: 'primary', width: 100, height: 50, className: 'mt-n8' }" @input="emit" />
            </template>
            <template v-if="mode == 'view'">
                {{ address }}
            </template>
        </template>
        <template slot="기업로고">
            <template v-if="mode == 'form'">
                <small class="grey--text">권장사이즈 : 230*68(px)</small>
                <v-file-input v-model="form.logo" outlined dense :prepend-icon="null" prepend-inner-icon="mdi-file-upload-outline" @change="emit" />
            </template>
            <template v-if="mode == 'view'">
                <image-popup :src="logo" :size="100" />
            </template>
        </template>
    </vertical-form-table>
</template>

<script>
import { rules, USER_TYPES } from "@/assets/variables";

import ImagePopup from "@/components/console/dumb/image-popup.vue";
import VAddressField from "@/components/dumb/v-address-field.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

const { COMPANY } = USER_TYPES;

export default {
    components: {
        ImagePopup,
        VAddressField,
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // form
        mode: { type: String, default: "view" },
    },
    data: () => ({
        form: {},

        rules,
        COMPANY,
    }),
    computed: {
        items() {
            let items = [
                {
                    key: "name",
                    term: "기업명",
                    type: "text",
                    required: true,
                    placeholder: "아이디를 입력하세요",
                    rules: rules[COMPANY.value]?.name,
                },
                {
                    // key: "businessRegistration",
                    term: "사업자등록증",
                    required: true,
                    rules: rules[COMPANY.value]?.businessRegistration,
                },
                {
                    key: "ceoName",
                    term: "대표자 성명",
                    type: "text",
                    required: true,
                    rules: rules[COMPANY.value]?.ceoName,
                },
                {
                    key: "email",
                    term: "이메일",
                    type: "email",
                    required: true,
                    rules: rules.email,
                },
                {
                    key: "website",
                    term: "홈페이지 주소",
                    type: "text",
                },
                {
                    key: "address",
                    term: "주소",
                    required: true,
                },
                {
                    term: "기업로고",
                },
            ];
            return items.map((item) => ({ ...item, outlined: true }));
        },
        businessRegistration() {
            if (this.form?.businessRegistration?.url) return this.form.businessRegistration.url;
            if (this.form?.businessRegistration instanceof File) return URL.createObjectURL(this.form.businessRegistration);
        },
        address() {
            const { postcode, address1, address2 } = this.form;

            let address = "";
            if (postcode) address += `[${postcode}] `;
            if (address1) address += `${address1} `;
            if (address2) address += `${address2} `;

            return address.trim();
        },
        logo() {
            if (this.form?.logo?.url) return this.form.logo.url;
            if (this.form?.logo instanceof File) return URL.createObjectURL(this.form.logo);
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = { ...this.value };
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style>
</style>